import * as React from 'react';

interface IProps {
	callback: (e: any) => any;
	shouldRegisterCallback: boolean;
	children: (ref: React.RefObject<any>) => JSX.Element;
}

class ClickOutside extends React.PureComponent<IProps> {
	containerRef = React.createRef();

	handleClickOutside = (e: any) => {
		const { callback } = this.props;
		const containerNode: any = this.containerRef.current;

		if (typeof callback !== 'function') {
			console.error('[ClickOutside]: callback prop should be a function');
		} else if (containerNode && containerNode.contains && !containerNode.contains(e.target)) {
			callback(e);
		}
	};

	componentDidMount() {
		const { shouldRegisterCallback } = this.props;
		// use bubble phase
		shouldRegisterCallback && document.addEventListener('click', this.handleClickOutside, { once: true });
	}

	componentDidUpdate() {
		const { shouldRegisterCallback } = this.props;
		// use bubble phase
		shouldRegisterCallback && document.addEventListener('click', this.handleClickOutside, { once: true });
	}

	componentWillUnmount() {
		document.removeEventListener('click', this.handleClickOutside);
	}

	render() {
		const { children } = this.props;
		if (typeof children !== 'function') {
			console.error('[ClickOutside]: children is expected to be a function');
			return null;
		} else {
			return children(this.containerRef);
		}
	}
}

export default ClickOutside;
